<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <BackButton
          :label="$t('general.button.back')"
          :to="{ name: 'analyticsHome' }"
          marginBottom="5"/>

      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Retrospektive
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">Betreutes Wohnen</h5>

        <Search
            :filters="filters"
            :loading="isSearching"
            :officeDropdown="officeDropdown"
            :unemployedDropdown="unemployedDropdown"
            @search="getCoachingList"
            @dropdown-fetch="handleDropdownSearch"
            @clear-dropdown="handleClearDropdown"/>

        <div class="row align-items-center justify-content-between">
          <div class="mt-3">
            <PerPage :values="[10, 25, 50, 100]" @update:perPage="getCoachingList"/>

            <div class="customExcelExport">
              <ExcelExportButton
                  :label="$t('general.excel_export')"
                  :loading="isExcelLoaded"
                  @click="getExcelExport"/>
            </div>
          </div>
        </div>

        <div class="table-responsive overflow-auto pt-4 mb-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Status</th>
              <th>Kunden</th>
              <th>Standort</th>
              <th>Start</th>
              <th>Ende</th>
              <th class="text-end">Gesamtbudget</th>
              <th class="text-end">Tatsächliches SOLL HEUTE</th>

              <th class="text-end">IST GESAMT</th>
              <th class="text-end">Anteil FK</th>
              <th class="text-end">Anteil AK</th>

              <th class="text-end">SOLL FK Gesamtbudget</th>
              <th class="text-end">SOLL AK Gesamtbudget</th>

              <th class="text-end">IST FK 70</th>
              <th class="text-end">IST AK 30</th>

              <th class="text-end">Rest FK Budget</th>
              <th class="text-end">Rest AK Budget</th>

              <th class="text-end">Rest FK tats. SOLL</th>
              <th class="text-end">Rest AK tats. SOLL</th>

              <th class="text-end">Differenz FK Budget</th>
              <th class="text-end">Differenz AK Budget</th>
              <th class="text-end">Filter AK</th>

              <th class="text-end">Verbrauchte Wochen</th>
              <th class="text-end">Gesamtwochenanzahl</th>
              <th class="text-end">Restwochen</th>

              <th class="text-end">ToDo FK pro Woche</th>
              <th class="text-end">ToDo AK pro Woche</th>

              <th class="text-end">Relativer Anteil an Wochen</th>
              <th class="text-end">FLS PRO WOCHE</th>

              <th class="text-end">STAND</th>
              <th class="text-end">STAND %</th>
              <th class="text-end">PROZENTUALE VERTEILUNG</th>
              <th class="text-end">FACHKRAFT 1</th>
              <th class="text-end">FACHKRAFT 1 UE</th>
              <th class="text-end">BETREUER 2</th>
              <th class="text-end">BETREUER 2 UE</th>
              <th class="text-end">UN FEHLT</th>
              <th class="text-end">EINFÜHRUNGSUNTERLAGEN</th>
              <th class="text-end">LETZTER TERMIN</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="coaching in coachingList?.retrospectiveData" :key="coaching.id">
              <td>{{ coaching?.status }}</td>
              <td>{{ coaching?.unemployedFirstName }} {{ coaching?.unemployedLastName }}</td>
              <td>{{ coaching?.location }}}</td>
              <td>{{ coaching?.startDate }}</td>
              <td>{{ coaching?.endDate }}</td>
              <td class="text-end">{{ coaching?.maxUnits }}</td>
              <td class="text-end">{{ coaching.potentialUnitsUpToDate }}</td>

              <td class="text-end">{{ coaching.unitsDoneUpToDate }}</td>
              <td class="text-end">{{ coaching.specialistPercentUpToDate }}</td>
              <td class="text-end">{{ coaching.supervisorPercentUpToDate }}</td>

              <td class="text-end">{{ coaching.specialistMaxUnits }}</td>
              <td class="text-end">{{ coaching.supervisorMaxUnits }}</td>

              <td class="text-end">{{ coaching.specialistUnitsDoneUpToDate }}</td>
              <td class="text-end">{{ coaching.supervisorUnitsDoneUpToDate }}</td>

              <td class="text-end">{{ coaching.specialistTotalUnitsLeft }}</td>
              <td class="text-end">{{ coaching.supervisorTotalUnitsLeft }}</td>

              <td class="text-end">{{ coaching.specialistUnitsLeftUpToDate }}</td>
              <td class="text-end">{{ coaching.supervisorUnitsLeftUpToDate }}</td>

              <td class="text-end">{{ coaching.specialistBudgetDifference }}</td>
              <td class="text-end">{{ coaching.supervisorBudgetDifference }}</td>
              <td class="text-end">{{ coaching.budgetDifferenceFilter }}</td>

              <td class="text-end">{{ coaching.weeksDoneUpToDate }}</td>
              <td class="text-end">{{ coaching.maxWeeks }}</td>
              <td class="text-end">{{ coaching.weeksLeft }}</td>

              <td class="text-end">{{ coaching.unitsForSpecialistInWeek }}</td>
              <td class="text-end">{{ coaching.unitsForSupervisorInWeek }}</td>

              <td class="text-end">{{ coaching.weeksDonePercent }}</td>
              <td class="text-end">{{ coaching.unitsInWeek }}</td>

              <td class="text-end">{{ coaching.unitsDone }}</td>
              <td class="text-end">{{ coaching.unitsDonePercent }}</td>
              <td class="text-end">{{ coaching.percentageDistribution }}</td>
              <td>{{ coaching.specialist }}</td>
              <td class="text-end">{{ coaching.unitsDoneBySpecialist }}</td>
              <td>{{ coaching.supervisor }}</td>
              <td class="text-end">{{ coaching.unsignedUnits }}</td>
              <td>{{ coaching.documentStatus }}</td>
              <td>{{ coaching.lastUnit }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="coachingList?.pagination?.total_pages ?? 0 > 1"
            :totalPages="coachingList?.pagination?.total_pages"
            :currentPage="coachingList?.pagination?.current_page"
            :totalItems="coachingList?.pagination?.total_items"
            :perPage="coachingList?.pagination?.items_per_page"
            @pagechanged="getCoachingList"/>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup lang="ts">
import analyticsService from '@/api/Analytics';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import {getAllUnemployedDropdown, getOfficeDropdown} from '@/shared/dropdowns';
import {downloadFile} from '@/shared/functions';
import Search from '@/views/App/Analytics/Retrospective/AssistedLivingCoaching/Search.vue';
import {onMounted, ref} from 'vue';
import ExcelExportButton from "@/components/ExcelExportButton.vue";
import BackButton from "@/components/button/BackButton.vue";

const now = new Date();

const day = String(now.getDate()).padStart(2, '0');
const month = String(now.getMonth() + 1).padStart(2, '0');
const year = now.getFullYear();

// ---------- Types ----------

interface ICoachingList {
  retrospectiveData: IRetrospectiveCoaching[],
  pagination: IPagination
}


export interface IRetrospectiveCoaching {
  id: number;
  status: string;
  unemployedFirstName: string;
  unemployedLastName: string;
  location: string;
  startDate: string;
  endDate: string;
  maxUnits: number;
  potentialUnitsUpToDate: number;
  unitsDoneUpToDate: number;
  specialistPercentUpToDate: number;
  supervisorPercentUpToDate: number;
  specialistMaxUnits: number;
  supervisorMaxUnits: number;
  specialistUnitsDoneUpToDate: number;
  supervisorUnitsDoneUpToDate: number;
  specialistTotalUnitsLeft: number;
  supervisorTotalUnitsLeft: number;
  specialistUnitsLeftUpToDate: number;
  supervisorUnitsLeftUpToDate: number;
  specialistBudgetDifference: number;
  supervisorBudgetDifference: number;
  budgetDifferenceFilter: number;
  weeksDoneUpToDate: number;
  maxWeeks: number;
  weeksLeft: number;
  unitsForSpecialistInWeek: number;
  unitsForSupervisorInWeek: number;
  weeksDonePercent: number;
  unitsInWeek: number;
  unitsDone: number;
  unitsDonePercent: number;
  percentageDistribution: number;
  specialist: string | null;
  unitsDoneBySpecialist: number;
  supervisor: string | null;
  unsignedUnits: number;
  documentStatus: string;
  lastUnit: string | null;
}

interface IFilters {
  officeIds?: number[];
  toDate: string;
  page: number,
  limit: number,
}

interface IPagination {
  total_pages: number;
  current_page: number;
  items_per_page?: number;
  total_items?: number;
}


// ---------- State ----------

const filters = ref<IFilters>({
  officeIds: [],
  toDate: `${day}.${month}.${year}`,
  page: 1,
  limit: 10,
});

const coachingList = ref<ICoachingList>();
const officeDropdown = ref([]);
const unemployedDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const isExcelLoaded = ref(false);

async function getExcelExport() {
  await downloadFile('/analytics/retrospective-excel-export/assisted-living-coaching',
      undefined,
      {
        ...filters.value,
        'officeIds[]': filters.value.officeIds,
      },
      false,
      'GET',
      isExcelLoaded
  )
}

async function getCoachingList(
    page = 1,
    perPage?: number,
    passedFilters?: IFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingList.value?.pagination?.items_per_page;

  try {
    const {data} = await analyticsService.getRetrospectiveAssistedLivingCoachingList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes!,
    });

    console.log(data)

    coachingList.value = data.data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

const handleDropdownSearch = async (
    searchTerm: string,
    type: string
) => {
  if (searchTerm.length < 3) return; //

  const filters = {
    searchTerm: searchTerm,
    searchTermFor: type
  }

  await getAllUnemployedDropdown(
      unemployedDropdown,
      'lastName',
      'lastName',
      filters
  )
};

const handleClearDropdown = () => {
  unemployedDropdown.value = [];
}


onMounted(async () => {
  await Promise.all([
    getOfficeDropdown(officeDropdown),
    getCoachingList()
  ]);

  isLoaded.value = true;
});
</script>

<style scoped>

</style>